<div class="bookmarks-sidebar">

    <div class="wrapper">
        <div class="bookmarks-header">
            <div class="bookmarks-title">
                Bookmarks
            </div>
            <div class="header-actions">
                @if (activeTab === 'my' && currentProject) {
                    <inline-svg src="Plus.svg" color="#A5B5BD" hoverColor="#7F8F98" class="header-help"
                                (click)="createNew()"></inline-svg>
                }
            </div>
        </div>
        <nav class="tab-bar">
            <div class="tab" [class.tab-selected]="activeTab === 'my'" (click)="getActiveTab('my')">My Bookmarks
            </div>
            <div class="tab" [class.tab-selected]="activeTab === 'shared'" (click)="getActiveTab('shared')">Shared
                Bookmarks
            </div>
        </nav>
        <div class="section-divider"></div>
        <div class="content">
            <div class="list-info">
                @if (!searchActive) {
                    @if (activeTab === 'my') {
                        <mat-checkbox
                                [indeterminate]="someChecked()"
                                [checked]="selectAll"
                                (change)="setAll($event.checked)"
                                matTooltip="Select/deselect all"
                        >
                        </mat-checkbox>
                    }
                    <span><span
                            class="counter">{{ getCheckedAmount() || total }}</span>{{ getCheckedAmount() ? ' selected' : '' }}
                        bookmarks</span>
                    <div class="spacer"></div>
                    @if (someChecked() || selectAll) {
                        <inline-svg
                                class="bulk-action"
                                src="trash.svg"
                                matTooltip="Bulk delete"
                                color="#A5B5BD"
                                hoverColor="#7F8F98"
                                (click)="bulkDelete()"
                        >
                        </inline-svg>
                    } @else {
                        <inline-svg
                                src="sort_by.svg"
                                matTooltip="Sort by"
                                [color]="!orderTrigger.menuOpen ? '#A5B5BD' : '#5E84F7'"
                                hoverColor="#7F8F98"
                                [matMenuTriggerFor]="orderMenu"
                                [ngClass]="{ active: orderTrigger.menuOpen }"
                                #orderTrigger="matMenuTrigger"
                        >
                        </inline-svg>
                        <inline-svg
                                src="search.svg"
                                (click)="toggleSearch()"
                                color="#A5B5BD"
                                hoverColor="#7F8F98"
                                matTooltip="Search bookmark"
                        ></inline-svg>
                        <mat-menu #orderMenu="matMenu">
                            <button
                                    mat-menu-item
                                    class="menu-slot"
                                    (click)="updateSortState('created_at:desc')"
                                    [ngClass]="{ active: sortState === 'created_at:desc' }"
                            >
                                <span>Newest first</span>
                            </button>
                            <button
                                    mat-menu-item
                                    class="menu-slot"
                                    (click)="updateSortState('created_at:asc')"
                                    [ngClass]="{ active: sortState === 'created_at:asc' }"
                            >
                                <span>Oldest first</span>
                            </button>
                            <button
                                    mat-menu-item
                                    class="menu-slot"
                                    (click)="updateSortState('name:asc')"
                                    [ngClass]="{ active: sortState === 'name:asc' }"
                            >
                                <span>A-Z</span>
                            </button>
                            <button
                                    mat-menu-item
                                    class="menu-slot"
                                    (click)="updateSortState('name:desc')"
                                    [ngClass]="{ active: sortState === 'name:desc' }"
                            >
                                <span>Z-A</span>
                            </button>
                        </mat-menu>
                    }
                } @else if (searchActive) {
                    <mat-form-field appearance="outline">
                        <inline-svg src="search.svg"
                                    color="#A5B5BD" matPrefix></inline-svg>
                        <div class="search-input">
                            <input
                                    matInput
                                    [formControl]="searchBookmarkCtrl"
                                    placeholder="Search..."
                            />
                        </div>
                        <div matSuffix class="search-suffix" (click)="$event.stopPropagation()">
                            <inline-svg
                                    color="#A5B5BD"
                                    hoverColor="#7F8F98"
                                    src="small_close.svg"
                                    (click)="clearSearch()"
                            ></inline-svg>
                        </div>
                    </mat-form-field>
                }
            </div>
            <div class="horizontal-separator"></div>
            <div class="bookmarks-list" (scroll)="onScroll($event)">
                @if (!isLoading && bookmarks.length === 0) {
                    <div class="no-results">
                        <inline-svg src="info-chat.svg" color="#A5B5BD" class="no-results-icon"></inline-svg>
                        <span class="no-results-title">
                            No bookmarks {{ searchActive ? 'found' : '' }}.
                        </span>
                        @if (searchActive) {
                            <span class="no-results-subtitle">
                            Please try adjusting search or
                            filter to find what you’re looking for.
                        </span>
                        }
                    </div>
                } @else if (isLoading && bookmarks.length === 0) {
                    <div class="loading-container" [ngClass]="{'spinner' : isLoading}">
                    </div>
                }
                @for (bookmark of bookmarks; track bookmark.id) {
                    <div class="bookmark-container" [ngClass]="{'active': isSelected(bookmark)}"
                         (click)="activateBookmark(bookmark)">
                        @if (activeTab === 'my') {
                            <mat-checkbox
                                    (click)="$event.stopPropagation()"
                                    [checked]="isSelected(bookmark)"
                                    (change)="bookmarkChecked(bookmark, $event)"
                            ></mat-checkbox>
                        }
                        <div class="bookmark-info">
                            <span class="name">{{ bookmark.name }}</span>
                            <div class="path">
                                <inline-svg
                                        [src]="activeTab === 'my'? 'project.svg' : 'Shared.svg'"
                                        class="project-icon" color="#A5B5BD"></inline-svg>
                                <span>{{ bookmark.project.name }}</span>
                                @if (bookmark.project.name !== bookmark.bookmark_metadata['folder_name']) {
                                    <inline-svg src="small_arrow.svg" class="arrow-icon"
                                                color="#A5B5BD"></inline-svg>
                                    @if (!isFolderDirrectProjectChild(bookmark.bookmark_metadata['folder'])) {
                                        <span>...</span>
                                        <inline-svg src="small_arrow.svg" class="arrow-icon"
                                                    color="#A5B5BD"></inline-svg>
                                    }
                                    <span>{{ bookmark.bookmark_metadata['folder_name'] }}</span>
                                }
                            </div>
                            @if (activeTab !== 'my') {
                                <span class="user">{{ bookmark.user.email }}</span>
                            }
                        </div>
                        @if (activeTab === 'my') {
                            <inline-svg
                                    src="Hamburger_menu.svg"
                                    class="item-menu"
                                    [matMenuTriggerFor]="actionMenu"
                                    #bookmarkMenuTrigger="matMenuTrigger"
                                    [color]="bookmarkMenuTrigger.menuOpen ? '#5E84F7' : '#A5B5BD'"
                                    hoverColor="#7F8F98"
                                    (click)="$event.stopPropagation()"
                            ></inline-svg>
                            <mat-menu #actionMenu="matMenu" class="action-menu">
                                <button
                                        mat-menu-item
                                        (click)="editBookmark(bookmark, $event, bookmarkMenuTrigger)"
                                        class="menu-slot"
                                >
                                    Rename
                                </button>
                                <button
                                        mat-menu-item
                                        (click)="bulkDelete(bookmark, bookmarkMenuTrigger)"
                                        class="menu-slot"
                                >
                                    Delete Bookmark
                                </button>
                            </mat-menu>
                        }
                    </div>
                }
            </div>
        </div>
    </div>
</div>